<template>
    <div class="flex flex--column flex--center__vert width--100 height--100">
        <div class="dashboard--header">
            <ActionButton icon="arrow-back" @onClick="$router.push('/notifications')"/>
        </div>
        <div class="dashboard--content pad--2 flex flex--column flex--grow overflowAuto">
            <label for="notification_title" class="input--label">Titel</label>
            <input id="notification_title" class="input--text mar--bottom__2" v-model="title"/>
            <label for="notification_description" class="input--label">Beschreibung</label>
            <textarea id="notification_description" class="input--text height--min__30 mar--bottom__2" v-model="description" />
            <div class="input--label">Nutzerziel</div>
            <v-select :options="options" label="title" :clearable="false" v-model="type" class="input--selection width--100 mar--bottom__2"/>
            <div v-if="type && type.hint" class="font--s14 mar--bottom__2">{{ type.hint }}</div>
            <div v-if="type && type.id === 3" class="flex flex--space__hor">
                <div class="input--label">
                    Kursliste
                </div>
                <div class="flex font--s14 font--w700">
                    <div class="mar--right__2">
                        Enthalten
                    </div>
                    <div>
                        Fehlend
                    </div>
                </div>
            </div>
            <div v-if="type && type.id === 3" class="flex flex--column">
                <div v-for="course in OKourses"
                     :key="course._id" class="flex flex--center__vert flex--space__hor border--bottom__light">
                    <div class="font--s16">{{ course.title }}</div>
                    <div class="flex">
                        <input :id="`included-${course._id}`"
                               type="checkbox"
                               :value="includedCourses.includes(course._id)"
                               @input="toggleCourse(course._id, true)" class="input--checkbox pad--05"/>
                        <label :for="`included-${course._id}`" class="flex flex--center">
                            <ion-icon name="checkmark" class="font--s3 color--primary" v-if="includedCourses.includes(course._id)"/>
                        </label>

                        <input :id="`excluded-${course._id}`"
                               type="checkbox"
                               :value="excludedCourses.includes(course._id)"
                               @input="toggleCourse(course._id, false)" class="input--checkbox pad--05"/>
                        <label :for="`excluded-${course._id}`" class="flex flex--center">
                            <ion-icon name="checkmark" class="font--s3 color--primary" v-if="excludedCourses.includes(course._id)"/>
                        </label>
                    </div>
                </div>
            </div>
            <label v-if="type && (type.id === 4 || type.id === 5)"
                   for="course_amount"
                   class="input--label">Kursanzahl</label>
            <input v-if="type && (type.id === 4 || type.id === 5)"
                   id="course_amount"
                   type="number"
                   min="1"
                   class="input--text mar--bottom__2"
                   v-model="courseAmount"/>

            <div v-if="error" class="font--s16 font--w700 mar--bottom__2" style="color: #c0392b">{{ error }}</div>

            <!-- Schritt 1: Empfänger zählen; Schritt 2: erst danach senden -->
            <AccentButton v-if="!preview" :title="busy ? 'Wird geprüft …' : 'Empfänger prüfen'" @onClick="checkRecipients"/>
            <div v-if="preview" class="flex flex--column">
                <div class="font--s16 mar--bottom__2">
                    <strong>{{ preview.totalUserCount }}</strong> Nutzer in der Zielgruppe,
                    davon <strong>{{ preview.reachedUserCount }}</strong> mit Gerät für Push.
                </div>
                <div v-if="preview.reachedUserCount === 0" class="font--s16 mar--bottom__2">
                    Niemand in dieser Zielgruppe kann eine Push-Nachricht empfangen.
                </div>
                <AccentButton v-if="preview.reachedUserCount > 0"
                              :title="busy ? 'Wird gesendet …' : `Jetzt an ${preview.reachedUserCount} Nutzer senden`"
                              @onClick="sendNotification"/>
                <div class="font--s14 mar--top__1 pointer" style="text-decoration: underline" @click="preview = null">Ändern</div>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-select/dist/vue-select.css';
    import vSelect from 'vue-select'
    import ActionButton from '@/components/ActionButton';
    import AccentButton from '@/components/AccentButton';

    const ACTIVITY_HINT = '„Zuletzt aktiv“ ist die letzte Nutzung der App. Kursfortschritt nur im Web zählt nicht.';

    export default {
        name: 'CreateNotificationView',
        components: {AccentButton, ActionButton, vSelect},
        data() {
            return {
                type: null,
                title: null,
                description: null,
                excludedCourses: [],
                includedCourses: [],
                courseAmount: null,
                preview: null,
                error: null,
                busy: false,
                options: [
                    {id: 1, type: 'active', title: 'Aktive Nutzer (App genutzt in den letzten 14 Tagen)', hint: ACTIVITY_HINT},
                    {id: 2, type: 'inactive', title: 'Inaktive Nutzer (zuletzt vor 15–90 Tagen genutzt)', hint: ACTIVITY_HINT},
                    {id: 7, type: 'longInactive', title: 'Lange inaktiv (zuletzt vor 91–365 Tagen genutzt)', hint: ACTIVITY_HINT},
                    {id: 8, type: 'communityActive', title: 'Community-Aktive (Beitrag oder Kommentar in 14 Tagen)'},
                    {id: 3, type: 'course', title: 'Kursbibliothek enthält/fehlt'},
                    {id: 4, type: 'courseCount', title: 'Mindestens X Kurse'},
                    {id: 5, type: 'courseCount', title: 'Maximal X Kurse'},
                    {id: 6, type: 'all', title: 'Alle Nutzer'},
                ]
            };
        },
        computed: {
            OKourses() {
                return this.$store.getters.OKourseCourses;
            },
        },
        watch: {
            // Jede Änderung macht die Vorschau ungültig
            type() { this.preview = null; },
            title() { this.preview = null; },
            description() { this.preview = null; },
            courseAmount() { this.preview = null; },
        },
        methods: {
            toggleCourse(id, include) {
                this.preview = null;
                if (include) {
                    if (this.includedCourses.includes(id)) {
                        this.includedCourses = this.includedCourses.filter((el) => el !== id);
                    } else {
                        this.includedCourses.push(id);
                    }
                } else {
                    if (this.excludedCourses.includes(id)) {
                        this.excludedCourses = this.excludedCourses.filter((el) => el !== id);
                    } else {
                        this.excludedCourses.push(id);
                    }
                }
            },
            payload() {
                const data = {title: this.title, message: this.description};
                if (this.type.id === 3) {
                    data.partOfCourse = this.includedCourses;
                    data.notPartOfCourse = this.excludedCourses;
                }
                if (this.type.id === 4 || this.type.id === 5) {
                    data.greaterThan = this.type.id === 4;
                    data.atLeastCount = Number(this.courseAmount);
                }
                return {type: this.type.type, data};
            },
            missingInput() {
                if (!this.title || !this.description) return 'Bitte Titel und Beschreibung ausfüllen.';
                if (!this.type) return 'Bitte ein Nutzerziel wählen.';
                if ((this.type.id === 4 || this.type.id === 5) && !(Number(this.courseAmount) >= 1)) return 'Bitte eine Kursanzahl ab 1 eingeben.';
                return null;
            },
            errorText(e) {
                const message = e && e.response && e.response.data && e.response.data.message;
                return `Das hat nicht geklappt${message ? `: ${message}` : '.'} Bitte erneut versuchen.`;
            },
            async checkRecipients() {
                if (this.busy) return;
                this.error = this.missingInput();
                if (this.error) return;
                this.busy = true;
                try {
                    this.preview = await this.$store.dispatch('previewNotification', this.payload());
                } catch (e) {
                    this.error = this.errorText(e);
                } finally {
                    this.busy = false;
                }
            },
            async sendNotification() {
                if (this.busy || !this.preview) return;
                this.busy = true;
                this.error = null;
                try {
                    await this.$store.dispatch('createNotification', this.payload());
                    this.$router.push('/notifications');
                } catch (e) {
                    this.error = this.errorText(e);
                } finally {
                    this.busy = false;
                }
            }
        },
        async mounted() {
            await this.$store.dispatch('retrieveOKourseCourses');
        },
    };
</script>
